import { render, staticRenderFns } from "./RepairByProductsBarchart.vue?vue&type=template&id=123eb544"
import script from "./RepairByProductsBarchart.vue?vue&type=script&lang=js"
export * from "./RepairByProductsBarchart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports